import axios from 'axios';
import apiUrl from '../../../constants'

export default new class {
  async getBookingList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargobooking/bookinglist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
  async getuploadlogList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/getuploadloglist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getBookingListForDownload(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargobooking/bookinglistfordownload',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

  async getBookingDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargobooking/bookingdetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
  async getInvoiceData(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargobooking/bookinginvoicedetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
  async getPickupLocationList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargobooking/pickuplocationlist',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
  async getConsigneeLocationList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/consigneelocationlist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async printMPS(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargobooking/printmps',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
  async printAWB(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/printawb',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveServiceability(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/saveserviceability',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async savePickupLocation(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/savepickuplocation',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveShipmentTotal(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/saveshipmenttotal',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveShipmentDimensions(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/saveshipmentdimensions',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveShipmentDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/saveshipmentdetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveBasicInformation(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/savebasicinformation',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveConsigneeDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/saveconsigneedetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveDetailedShipmentDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/savedetailedshipmentdetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveInvoiceAndGSTDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/saveinvoiceandgstdetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveValueAddedServices(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/savevalueaddedservices',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveDetailedInformation(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/savedetailedinformation',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async checkPincodeServicability(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/checkpincodeservicability',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async validateEWB(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/validateewb',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async pushBookingDatatoManifest(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/pushBookingDataToManifest',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async validateXLSXdata(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/validatexlsxdata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async uploadBookingData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/uploadbookingdata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getMPSDetailsByBookingId(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/getmpsdetailsbybookingid',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async generateAWB(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/generateawb',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientAwbCountList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/getclientawbcount',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async printmps(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': 'http://localhost:8081/api/cargobooking/printmps',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error("Please Install Printing Device");
    }
  };
  async printmpslogs(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'printstickerlogs/printmpslogs',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error("Please Install Printing Device");
    }
  };
  async verifyHSN(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/verifyHSN',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async GetPendingPushToManifestBookingList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/GetPendingPushToManifestBookingList',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async GetFlipkartClientList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/getfcclientdetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async FlipkartUpload(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/flipkartupload',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async PushFlipkartValidRecords(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/pushvalidflipkartrecords',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async TMPLUpload(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/tmplupload',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async PushTMPLValidRecords(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/pushvalidtmplrecords',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async B2BMarketplaceUpload(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/b2bmarketplaceupload',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async PushB2BMarketplaceValidRecords(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/pushvalidb2bmarketplacerecords',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async PrintMpsStickers(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/printmpsstickers',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async GetAbfrlSummaryData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/getabfrlsummarydata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async GetAbfrlProcessLogs(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/getabfrlprocesslogs',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async GetAbfrlWarehouseData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/getabfrlwarehousedata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async SaveAbfrlWarehouseData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/saveabfrlwarehousedata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async GetAbfrlCustomerData (input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/getabfrlcustomerdata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async SaveAbfrlCustomerData (input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/saveabfrlcustomerdata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async ebnLimitStates() {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargobooking/getebnlimitstates',
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
  async getProductCategoryList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoexternal/getProductCategoryList',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  }
  async getBookingDetailsForApiBooking(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cargobooking/getviewdetailsforapibooking',
        'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
  async getApiBookingListForDownload(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/apibookinglistfordownload',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async GetConfigDetailsFromKey(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'config/getconfigdetailsfromkey',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getCargoSellerDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/getSellerdetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveSellerDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/SaveCargoSellerDetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getCargoFCAddressDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/GetFCAdressDetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveFCDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/SaveFCAddressDetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async UploadFtcCashMemo(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/uploadftccashmemo',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async SaveFtcCashMemo(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/saveftccashmemo',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getFTCCashmemoDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargotripmanagement/getftccashmemodetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientFileType(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/getClientFileType',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async PushExcelValidRecords(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/pushValidExcelRecords',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getBookingCount(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoexternal/dashboard/getBookingCount',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async ValidateGenericClientData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/validategenericclientdata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async ValidateFCData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/validatefcdata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async ValidateTMPLData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/validatetmpldata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getFCuploaddata(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/fetchfcRecords',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err)
    }
  };
  async getGenericUploadData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/fetchgenericuploadrecords',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err)
    }
  }
  async getAirCargoData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/getaircargodetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err)
    }
  }
  async getAirCargoBill(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargotripmanagement/getaircargobill',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err)
    }
  }
  async deductPaymentFromWallet(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargotripmanagement/aircargo/payment',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err)
    }
  }
  async AirCargoCalculator(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/aircargocalculator',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err)
    }
  }
  async updateBookingDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/saveupdatebookingdetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err)
    }
  };
  async getB2BVendorSupplementoryAddressDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'b2bmarketplace/getvendorsupplementoryaddressdetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getB2BMarketplaceVendorlist(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'b2bmarketplace/vendorlist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveB2BVendorDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'b2bmarketplace/savevendordetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getB2BMarketplaceClientlist(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'b2bmarketplace/getclientlist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getB2BMarketplaceDeliverylist(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'b2bmarketplace/deliverylist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async saveB2BDeliveryDetails(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'b2bmarketplace/savedeliverydetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async GetManifestionPendingMPSList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/getmanifestationpendingmps',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async pushMPSDatatoManifest(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargobooking/pushmanifestationpendingmps',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getAirlineData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/getairlinedetails',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err)
    }
  };
  async downloadAirlineData(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargobooking/getallairlinedata',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err)
    }
  };
  async getWalletBalance(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url +'cargotripmanagement/aircargo/getwalletbalance',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err)
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/services/cargobooking.service.js